import React from 'react';
import { PropTypes } from 'prop-types';

import { texts } from 'utils/languages/fr';
import { CustomFormLabel, InfoButton } from 'components';
import { MuiTelInput } from 'mui-tel-input';
import { Box, FormControl, FormHelperText, Typography } from '@mui/material';

const CustomPhoneField = props => {
    const {
        error,
        label,
        showError = true,
        disabled,
        fullWidth,
        sx,
        hideInfoButton,
        ...rest
    } = props;

    return (
        <FormControl fullWidth={fullWidth} error={!!error}>
            {label && <CustomFormLabel>{label}</CustomFormLabel>}
            <Box display="flex" alignItems="center">
                <MuiTelInput
                    langOfCountryName="fr"
                    defaultCountry="FR"
                    variant="outlined"
                    placeholder="+3197010281517"
                    fullWidth={fullWidth}
                    error={!!error && showError}
                    disableDropdown={disabled}
                    disabled={disabled}
                    sx={theme => ({
                        marginBottom: 0,
                        ...(typeof sx === 'function' ? sx(theme) : sx),
                    })}
                    {...rest} // those props can override the defaults above
                />
                {!hideInfoButton && (
                    <InfoButton
                        disableMarginBottom
                        title={texts.TELEPHONE}
                        content={
                            <React.Fragment>
                                <Typography gutterBottom>
                                    {texts.LE_NUMERO_SERA_UTILISE_POUR_ENVOYER}
                                </Typography>
                                <Typography>{texts.VERIFIEZ_LE_NUMERO}</Typography>
                            </React.Fragment>
                        }
                    />
                )}
            </Box>
            {!!error && showError && <FormHelperText error={!!error}>{error}</FormHelperText>}
        </FormControl>
    );
};

CustomPhoneField.propTypes = {
    showError: PropTypes.bool,
    hideInfoButton: PropTypes.bool,
};

export default CustomPhoneField;
